module.exports = __webpack_public_path__ + "img/clientesLandPage.4e335632.png";